import { render, staticRenderFns } from "./LastDocuments.vue?vue&type=template&id=63407212&"
import script from "./LastDocuments.vue?vue&type=script&lang=js&"
export * from "./LastDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports